import { FC } from 'react';

import { useTranslate } from 'hooks/useTranslate';

const RINGS = [
  { scale: 1.4, opacity: 0.18, delay: '0s' },
  { scale: 1.75, opacity: 0.1, delay: '0.4s' },
  { scale: 2.15, opacity: 0.05, delay: '0.8s' },
];

const NoAccessState: FC = () => {
  const { t } = useTranslate();

  return (
    <div className="navi-no-access">
      <div className="navi-no-access__card">
        <div className="navi-no-access__orb-wrap">
          {RINGS.map((r, i) => (
            <span
              // eslint-disable-next-line react/no-array-index-key
              key={i}
              className="navi-no-access__ring"
              style={{
                transform: `scale(${r.scale})`,
                opacity: r.opacity,
                animationDelay: r.delay,
              }}
            />
          ))}
          <div className="navi-no-access__icon-circle">
            <em className="icon ni ni-lock-alt" />
          </div>
        </div>

        <p className="navi-no-access__eyebrow">
          {t('CHATBOT_NoAccess_Eyebrow')}
        </p>
        <h2 className="navi-no-access__title">
          {t('CHATBOT_NoAccess_Title')}
        </h2>
        <p className="navi-no-access__description">
          {t('CHATBOT_NoAccess_Description')}
        </p>

        <a
          href="mailto:info@sttok.com"
          className="navi-no-access__cta"
        >
          <em className="icon ni ni-mail" />
          <span>{t('CHATBOT_NoAccess_CTA')}</span>
        </a>

        <p className="navi-no-access__hint">
          {t('CHATBOT_NoAccess_Hint')}
        </p>
      </div>
    </div>
  );
};

export default NoAccessState;
